import anharPic from "../images/crew/anhar-image.jpg";
// import damonPic from "../images/crew/damon-bw.jpeg";
import erykPic from "../images/crew/eryk-bw.jpeg";
// import gretchPic from "../images/crew/GScottHeadShotB&W.png";
import harrisonPic from "../images/crew/harrison-bw.jpeg";
import lindaPic from "../images/crew/linda-bw.jpeg";
import mattPic from "../images/crew/matt-pic-modified.jpeg";
import michaelPic from "../images/crew/michael-lai-bw.png";
import patPic from "../images/crew/pat-b&w-pic.png";
import simonPic from "../images/crew/simon-dwyer-bw.jpeg";
// import stevePic from "../images/crew/scuba-steve-bw.jpeg"

const bootcampList = [
	{
		name: "Michael Lai",
		liskovTitle: "Head of UX Design; teacher",
		currentWorkTitle: "Contracting Designer",
		photoSrc: michaelPic,
		photoAlt: "Michael Lai",
		shortBio:
			"Scientist, UX Designer, Origamist. Michael has applied his evidence-based and data-driven approach to design for not-for-profit organizations, start-ups and global companies as well as federal and state government projects. Former UX Instructor at General Assembly.",
		longBio:
			"Michael has applied his evidence-based and data-driven approach to design for not-for-profit organizations, start-ups and global companies as well as federal and state government projects. Former UX Instructor at General Assembly.",
	},
	{
		name: "Matt McKenzie",
		liskovTitle: "Head of Coding; Teacher",
		currentWorkTitle: "Dev at Everest Engineering",
		photoSrc: mattPic,
		photoAlt: "Matt McKenzie",
		alt: "Matt McKenzie",
		shortBio:
			"Matt was a teacher at Coder Academy for four cohorts, and has experience as a teaching consultant and consultant dev with NSW Government and now at Everest Engineering.",
		longBio: "",
	},
	{
		name: "Patrick Smith",
		liskovTitle: "Course content and Liskov Advanced",
		currentWorkTitle: "Consultant Product Developer / Design Engineer",
		photoSrc: patPic,
		photoAlt: "Patrick Smith",
		shortBio:
			"Patrick is a programming polyglot with over 15 years of front and backend experience. He has been the lead teacher for three cohorts of the Fast Track program at Coder Academy.",
		longBio: "",
	},
	// {
	//     name: "Gretchen Scott",
	//     liskovTitle: "Industry relationships",
	//     currentWorkTitle: "CEO @ The Human Collective | Network Director @ Women Who Code Melbourne | Coach @ Startmate",
	//     photoSrc: gretchPic,
	//     photoAlt: "Gretchen Scott",
	//     shortBio: "Gretchen was a teacher at Coder Academy, has since been involved with Linc, and now runs the Human Collective (among many other things).",
	//     longBio: "",
	// },
	{
		name: "Harrison Malone",
		liskovTitle: "Teacher",
		currentWorkTitle: "Software Engineer at Mr Yum",
		photoSrc: harrisonPic,
		photoAlt: "Harrison Malone",
		shortBio:
			"Harrison was an educator at Coder Academy for 2 years and is now a software engineer at Mr Yum.",
		longBio:
			"Harrison was an educator at Coder Academy for 2 years before starting at 99designs as a Software Engineer in April 2021. He has significant experience in helping students get hired as junior developers being both a bootcamp student (at Le Wagon) and facilitator.",
	},
	{
		name: "Simon Dwyer",
		liskovTitle: "Teacher",
		currentWorkTitle: "Software Engineer at Marketplacer",
		photoSrc: simonPic,
		photoAlt: "Simon Dwyer",
		shortBio:
			"Simon Dwyer is a backend developer and custodian lead at Marketplacer. He loves pragmatic code and helping junior devs succeed (oh... and dogs).",
		longBio: "",
	},
	{
		name: "Anhar Zihan",
		liskovTitle: "Mentor",
		currentWorkTitle: "Software Engineer at 99Designs",
		photoSrc: anharPic,
		photoAlt: "Anhar Zihan",
		shortBio:
			"Anhar is currently at 99Designs. She worked as a teacher at Coder Academy, and also for Energy Australia.",
		longBio:
			"Anhar was a Teaching Assistant at Coder Academy for two cohorts before joining Energy Australia as a Software Developer in December 2019. Being a bootcamp graduate herself, she knows what it takes to transition into software development and is passionate about helping individuals like herself to make it in this industry.",
	},
	{
		name: "Linda Lai",
		liskovTitle: "Mentor",
		currentWorkTitle: "Software Engineer at Zendesk",
		photoSrc: lindaPic,
		photoAlt: "Linda Lai",
		shortBio:
			"Linda is a dev who is currently a software engineer at Zendesk. She has helped teach a coding short course at Coder Academy.",
		longBio: "",
	},
	{
		name: "Eryk Grasela",
		liskovTitle: "Mentor",
		currentWorkTitle: "Senior Software Engineer at REA",
		photoSrc: erykPic,
		photoAlt: "Eryk Grasela",
		shortBio:
			"Eryk has worked across various roles, from consulting through to becoming a Senior Dev at REA Group.",
		longBio: "",
	},
	// {
	//     name: "Steve Christenson",
	//     liskovTitle: "Advisor",
	//     currentWorkTitle: "Software Engineer at Envato",
	//     photoSrc: stevePic,
	//     photoAlt: "Steve Christenson",
	//     shortBio: "Steve is a software engineer at Envato, and has previously worked at Marketplacer. He has also taught at Coder Academy.",
	//     longBio: "",
	// },
];

// const consultingList = [
// 	{
// 		name: "Damon Smith",
// 		liskovTitle: "Head of Engineering",
// 		currentWorkTitle: "Engineering Lead at Australia Post",
// 		photoSrc: damonPic,
// 		photoAlt: "Damon Smith",
// 		shortBio:
// 			"Damon has been in the software engineering game for a quarter century, his career spanning many comapnies, and from the UK to Australia.",
// 		longBio: "",
// 	},
// ];

function Content() {
	return (
		<section className="liskov-who">
			<div id="who-section"></div>
			<h2>Who is running this thing?</h2>
			<div className="collaborator-grid">
				{bootcampList.map((crewMember) => {
					return (
						<div className="name-and-pic">
							<img src={crewMember.photoSrc} alt={crewMember.photoAlt} />
							<h3>{`${crewMember.name} (${crewMember.liskovTitle});`}</h3>
							<h4>{`${crewMember.currentWorkTitle};`}</h4>
							<p>{crewMember.shortBio}</p>
						</div>
					);
				})}
			</div>
			{/* <h2>
            Liskov Consulting
        </h2>
        <div className="collaborator-grid">
            {
                consultingList.map(crewMember => {
                    return (
                        <div className="name-and-pic">
                            <img src={crewMember.photoSrc} alt={crewMember.photoAlt} />
                            <h3>
                                { `${ crewMember.name } (${ crewMember.liskovTitle });` }
                            </h3>
                            <h4>
                                { `${ crewMember.currentWorkTitle };` }
                            </h4>
                            <p>
                                {crewMember.shortBio}
                            </p>
                        </div>
                    )
                })
            }
        </div> */}
		</section>
	);
}

export default Content;
